import { render, staticRenderFns } from "./BStep.vue?vue&type=template&id=05dacfdc&scoped=true&"
import script from "./BStep.vue?vue&type=script&lang=js&"
export * from "./BStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dacfdc",
  null
  
)

export default component.exports